export class ViewDashboardContract {
	public contractId: string;
	public contractNum: string;
	public rfqSessionId: string;
	public dbaName: string;
	public serviceTypeId: string;
	public stateId: string;
	public utilityId: string;
	public isResidential: boolean;
	public status: number;
	public displayStatus: string;
	public rate: number;
	public displayPtc: string;
	public displayPtcRaw: number;
	public displayPreviousContractRate: string;
	public displayPreviousContractRateRaw: number;
	public displayBaseRateOverride: string;
	public displayBaseRateOverrideRaw: number;
	public displayIndicativeRate: string;
	public displayIndicativeRateRaw: number;
	public submissionStatus: number;
	public submissionStatusAutoSubmittedDate: string;
	public annualUsage: number;
	public baseRateOverride: number;
	public previousContractRate: number;
	public units: string;
	public marginUnits: string;
	public rejectReason: string;
	public rejectReasonSubCategoryId: number;
	public depositRequiredAmount: number;
	public companyId: string;
	public isSaas: boolean;
	public effectiveDate: Date;
	public expirationDate: Date;
	public ptc: number;
	public indicativeRate: number;
	public isPurchasingLayerContract: boolean;
	public confirmationDate: Date;
	public isRenewal: boolean;
	public isExternalRenewal: boolean;
	public isNewCustomer: boolean;
	public isRenewalProspect: boolean;
	public agentId: string;
	public customerId: string;
	public parentId: string;
	public brotherId: string;
	public hideContractDetailsFromBrother: boolean;
	public previousContractExpirationMonth: string;
	public displayAnnualUsage: number;
	public currentPrice: number;
	public displayCurrentPrice: string;
	public displayCurrentPriceRaw: number;
	public showDepositRequiredMessage: boolean;
	public showHoldSubmissionStatus: boolean;
	public showAutoSubmissionStatus: boolean;
	public fitsAboutLayeredPurchasingReq: boolean;
	public isRejectedCommercial: boolean;
	public isAboveUsageThreshold: boolean;
	public showRequestPrice: boolean;
	public showStatusButton: boolean;
	public showStatusNoButton: boolean;
	public symbol: string;
	public symbol2: string;

	// internal properties
	public editingCurrentPrice: boolean;
	public savingCurrentPrice: boolean;

	constructor(viewDashboardContract?: Partial<ViewDashboardContract>) {
		Object.assign(this, viewDashboardContract);
	}
}
